// extracted by mini-css-extract-plugin
export default {"form":"PageDataInputs_form__iPoTa","section-data":"PageDataInputs_section-data__mgpod","div-button":"PageDataInputs_div-button__TTybc"};